export default __webpack_public_path__ + "static/media/giphy.a7068e84.gif";